// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__2jRu5","footer__main-menu":"footer_footer__main-menu__1aDd0"};